/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoSetUserAsAdminDto
 */
export interface WebApiAdminDtoSetUserAsAdminDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetUserAsAdminDto
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetUserAsAdminDto
     */
    companyId?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoSetUserAsAdminDto interface.
 */
export function instanceOfWebApiAdminDtoSetUserAsAdminDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSetUserAsAdminDtoFromJSON(json: any): WebApiAdminDtoSetUserAsAdminDto {
    return WebApiAdminDtoSetUserAsAdminDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSetUserAsAdminDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSetUserAsAdminDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
    };
}

export function WebApiAdminDtoSetUserAsAdminDtoToJSON(value?: WebApiAdminDtoSetUserAsAdminDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'companyId': value.companyId,
    };
}

